import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/tabs/select_deporte'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage.vue')
  },
  {
    path: '/register',
    component: () => import('@/views/RegisterPage.vue')
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: 'select_deporte'
      },
      {
        path: 'select_deporte',
        component: () => import('@/views/Tab1Page.vue')
      },
      {
        path: 'select_fecha',
        component: () => import('@/views/Tab1_1Page.vue')
      },
      {
        path: 'select_modalidad/:reserva_id?',
        component: () => import('@/views/Tab1_2Page.vue')
      },
      {
        path: 'mis_reservas',
        component: () => import('@/views/Tab2Page.vue')
      },
      {
        path: 'mis_creditos',
        component: () => import('@/views/Tab3Page.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
